import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-730f59b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "利用者ガイドライン", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "斜向のガイドラインをご覧いただき、ありがとうございます。", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "斜向が提供する配布物やホームページをご利用いただくにあたり、利用者の皆様に向けたお約束をまとめましたので、ご一読の上ご協力のほどよろしくお願いいたします！", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "各種SNSのフォロー", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "斜向では団体としての活動のほかに、メンバー個人でも様々な製作物を制作し、公開しております。", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "様々な制作活動の原動力としてダウンロードやフォローによる皆様からのご反応を嬉しく拝見しておりますので、ぜひご助力ください！", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "発信内容に関するお願い", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("斜向では、配布マップのプレイ配信や動画投稿、感想の投稿、２次創作などの製作物に関する発信を"),
  /*#__PURE__*/_createElementVNode("b", null, "歓迎しています！")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Twitterや各種SNSに投稿する際には「#斜向」や各作品のタグを付けていただけますと当団体の方で認知しやすくなり、制作の励みになります！", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "以上の事柄をお守りいただいた上で、斜向が提供する配布ワールドをはじめとする様々な作品をお楽しみください！", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "２０２３年５月１５日 施行", -1))

import IconLink from '@/components/utils/IconLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuidelineView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(IconLink, {
          href: "https://twitter.com/hsmkai",
          icon: "Twitter"
        }, {
          default: _withCtx(() => [
            _createTextVNode("斜向 (Twitter)")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(IconLink, {
          href: "https://www.youtube.com/channel/UCRb01Kwyx9638bL4AtaYYfA",
          icon: "YouTube"
        }, {
          default: _withCtx(() => [
            _createTextVNode("斜向 (YouTube)")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(IconLink, {
          href: "https://twitter.com/txkodo",
          icon: "Twitter"
        }, {
          default: _withCtx(() => [
            _createTextVNode("txkodo (Twitter)")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(IconLink, {
          href: "https://github.com/txkodo",
          icon: "GitHub"
        }, {
          default: _withCtx(() => [
            _createTextVNode("txkodo (GitHub)")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(IconLink, {
          href: "https://twitter.com/CivilT_T",
          icon: "Twitter"
        }, {
          default: _withCtx(() => [
            _createTextVNode("CivilTT (Twitter)")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(IconLink, {
          href: "https://github.com/CivilTT",
          icon: "GitHub"
        }, {
          default: _withCtx(() => [
            _createTextVNode("CivilTT (GitHub)")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(IconLink, {
          href: "https://twitter.com/kswmcHi",
          icon: "Twitter"
        }, {
          default: _withCtx(() => [
            _createTextVNode("柏餅々々々 (Twitter)")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(IconLink, {
          href: "https://twitter.com/24ki05",
          icon: "Twitter"
        }, {
          default: _withCtx(() => [
            _createTextVNode("二式 (Twitter)")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _createElementVNode("p", null, [
      _createTextVNode("なお、動画やSNSへの投稿に対して、斜向では"),
      _createVNode(_component_router_link, { to: "broadcast" }, {
        default: _withCtx(() => [
          _createTextVNode("別途規約")
        ]),
        _: 1
      }),
      _createTextVNode("を定めていますので、こちらもご確認ください。")
    ]),
    _hoisted_14,
    _hoisted_15,
    _hoisted_16
  ]))
}
}

})